import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { push } from 'react-router-redux';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import { getUserBookedSessionEvents } from '../actions/sessionsActions';
import i18n from '../utils/i18n';
import './styles/MyBookingsScreen.scss';
import UserBookedSessionCardContainer from '../containers/UserBookedSessionCardContainer';
import UserBookedCourtCardContainer from '../containers/UserBookedCourtCardContainer';
import routeConstants from '../utils/routeConstants';

class MyBookings extends React.Component {
  constructor() {
    super();
    this.routeToSessions = this.routeTo.bind(
      this,
      routeConstants.SESSIONS_ROUTE
    );

    this.routeToCourts = this.routeTo.bind(this, routeConstants.COURTS_ROUTE);
  }

  componentDidMount() {
    this.props.getUserBookedSessionEvents();
  }

  routeTo(route) {
    this.props.dispatch(push(route));
  }

  render() {
    const { userBookedEvents } = this.props;
    const bookedSessions =
      userBookedEvents && userBookedEvents.booked_session_events;

    const bookedCourts =
      userBookedEvents && userBookedEvents.booked_court_events;

    const sessionsBooked = bookedSessions && bookedSessions.length > 0;

    const courtsBooked = bookedCourts && bookedCourts.length > 0;

    return (
      <HeaderContainerTemplate>
        <Container>
          <div className="my-bookings-screen-wrapper">
            {this.props.fetchingUserBookedEvents ? (
              <div className="sessions-statement">
                {i18n.t('upcomingBookings.FETCHING_BOOKINGS')}
              </div>
            ) : (
              <div>
                <div className="user-booked-event-wrapper">
                  <Row>
                    <Col>
                      <div className="header2 upcoming-header">
                        {i18n.t('upcomingBookings.UPCOMING_SESSIONS')}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    {sessionsBooked ? (
                      <div className="events">
                        <div className="cards">
                          {bookedSessions.map(event => (
                            <div className="card-wrapper" key={ event.id }>
                              <UserBookedSessionCardContainer
                                availableSpaces={ event.available_spaces }
                                eventDate={ event.event_date }
                                startTime={ event.start_time }
                                clubName={ event.venue_club_name }
                                clubAddress={ event.venue_address }
                                coachName={ event.coach_name }
                                coachPicture={ event.coach_pic }
                                participantsGoing={ event.number_of_attendees }
                                sessionName={ event.name }
                                sessionSubname={ event.sub_name }
                                sessionPicture={ event.picture }
                                sessionEventId={ event.id }
                                refreshAction={
                                  this.props.getUserBookedSessionEvents
                                }
                                pendingBooking={
                                  event.id === this.props.pendingBookingEventId
                                }
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div
                          className="no-bookings-yet"
                          onClick={ this.routeToSessions }
                        >
                          <span>
                            {i18n.t(
                              'upcomingBookings.NO_BOOKING_YET_SESSIONS_WILL'
                            )}
                            {' '}
                          </span>
                          <span className="link">
                            {i18n.t('upcomingBookings.BOOK_A_SESSION_NOW')}
                          </span>
                        </div>
                      </div>
                    )}
                  </Row>
                </div>
                <div className="user-booked-event-wrapper courts-wrapper">
                  <Row>
                    <Col>
                      <div className="header2 upcoming-header">
                        {i18n.t('upcomingBookings.UPCOMING_COURTS')}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    {courtsBooked ? (
                      <div className="events">
                        <div className="cards">
                          {bookedCourts.map(event => (
                            <div className="card-wrapper" key={ event.id }>
                              <UserBookedCourtCardContainer
                                courtEventId={ event.id }
                                eventDate={ event.event_date }
                                startTime={ event.start_time }
                                clubName={ event.venue_club_name }
                                clubAddress={ event.venue_address }
                                courtType={ event.court_type }
                                invitedBy={
                                  event.invited_booking
                                    ? event.invited_by_name
                                    : ''
                                }
                                refreshAction={
                                  this.props.getUserBookedSessionEvents
                                }
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div
                          className="no-bookings-yet"
                          onClick={ this.routeToCourts }
                        >
                          <span>
                            {i18n.t(
                              'upcomingBookings.NO_BOOKING_YET_COURTS_WILL'
                            )}
                            {' '}
                          </span>
                          <span className="link">
                            {i18n.t('upcomingBookings.BOOK_A_COURT_NOW')}
                          </span>
                        </div>
                      </div>
                    )}
                  </Row>
                </div>
              </div>
            )}
          </div>
        </Container>
      </HeaderContainerTemplate>
    );
  }
}

MyBookings.propTypes = {
  fetchingUserBookedEvents: PropTypes.bool,
  userBookedEvents: PropTypes.shape({}),
  getUserBookedSessionEvents: PropTypes.func.isRequired,
  pendingBookingEventId: PropTypes.number,
  dispatch: PropTypes.func.isRequired
};

MyBookings.defaultProps = {
  fetchingUserBookedEvents: false,
  userBookedEvents: {},
  pendingBookingEventId: null
};

const mapStateToProps = state => ({
  fetchingUserBookedEvents: state.userBookedEvents.loading,
  userBookedEvents: state.userBookedEvents.data || {}
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  getUserBookedSessionEvents: () => dispatch(getUserBookedSessionEvents())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyBookings);



// WEBPACK FOOTER //
// ./src/scenes/MyBookings.js